import React from 'react';
import { getStyledSystemProps } from 'src/helpers';
import { StyledLabel, StyledLabelProps, StyledRadioInput, FakeRadioButton } from './RadioButton.styled';

export type RadioButtonProps = StyledLabelProps &
  React.InputHTMLAttributes<HTMLInputElement> &
  RequireOnlyOne<
    {
      id: string;
      checked: boolean;
      defaultChecked: boolean;
      error?: boolean;
      onChange: (event: any) => void;
      onBlur?: (event: any) => void;
      children: React.ReactNode;
    },
    'checked' | 'defaultChecked'
  >;

export const RadioButton = ({
  id,
  children,
  defaultChecked,
  checked,
  disabled,
  error,
  variant,
  size,
  style = {},
  ...rest
}: RadioButtonProps) => {
  const [styledProps, radioButtonProps] = getStyledSystemProps(rest);

  return (
    <StyledLabel
      className={`${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}
      variant={variant}
      {...styledProps}
    >
      <StyledRadioInput {...{ id, defaultChecked, checked, disabled }} {...radioButtonProps} />
      <FakeRadioButton style={style} className="fake-radio-button" size={size} error={error}>
        {children}
      </FakeRadioButton>
    </StyledLabel>
  );
};

export default RadioButton;
